<template>
    <tr
        data-spec-class="table-row"
        class="border-t border-divider first:border-t-0"
    >
        <slot />
    </tr>
</template>
